import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PhoneAppState } from 'projects/store/src/app/services/api/v1/phone-app-status.service';

@Component({
  selector: 'app-phone-app-footer-button-shared',
  templateUrl: './phone-app-footer-button-shared.component.html'
})
export class PhoneAppFooterButtonSharedComponent {
  @Input() state: PhoneAppState = PhoneAppState.Waiting;
  @Output() continueClick = new EventEmitter<void>();

  get label(): string {
    return this.state === PhoneAppState.Ready ? 'Continuar' : 'Esperando confirmación de registro';
  }

  get loading(): boolean {
    return this.state === PhoneAppState.Waiting;
  }
}